import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { GlobalCompany, GridOverrides, TeamSettingResponse, TeamSettingSection } from '@mds/common';
import { MakersiteService } from '@services/makersite.service';
import { FormDataService, TabComponent } from '@mds/ui';
import { ScipSettingsComponent } from '../components/scip-settings/scip-settings.component';
import { SsoSettingsComponent } from '../components/sso-settings/sso-settings.component';
import { EpdSettingsComponent } from '../components/epd-settings/epd-settings.component';
import { TeamSettingsTabComponent } from '../components/team-settings-tab/team-settings-tab.component';
import { MemberSettingsComponent } from '../components/member-settings/member-settings.component';
import { SsoProviderSettingsComponent } from '../components/sso-provider-settings/sso-provider-settings.component';
import { DataSourcesSettingsComponent } from '../components/data-sources-settings/data-sources-settings.component';
import { DATA_SOURCES_SECTION_NAME } from '../components/data-sources-settings/constants/data-source.constants';
import { MdsIcon, MdsIconsModule } from '@mds/icons';

@Component({
  selector: 'app-team-settings',
  standalone: true,
  imports: [
    ScipSettingsComponent,
    SsoSettingsComponent,
    EpdSettingsComponent,
    TeamSettingsTabComponent,
    MemberSettingsComponent,
    SsoProviderSettingsComponent,
    DataSourcesSettingsComponent,
    MdsIconsModule,
    TabComponent
],
  templateUrl: './team-settings.component.html',
  styleUrls: ['./team-settings.component.scss'],
  providers: [
    {
      provide: FormDataService,
      useFactory: (svc: MakersiteService) => new FormDataService(svc),
      deps: [MakersiteService]
    }
  ]
})
export class TeamSettingsComponent implements OnInit {
  icons = MdsIcon;
  tabs = [
    { label: 'Members' },
    { label: 'Team Settings' },
    { label: 'EPD' },
    { label: 'SSO' },
    { label: 'SSO Providers' },
    { label: 'SCIP Legal Entity' },
    { label: 'Data Sources' }
  ];
  selectedTab = 'Members';

  userRid: string;
  teamRid: string;
  teamName: string;
  teamMembers: any[];
  isUserTeamAdmin: boolean;
  teamInfo: any;
  actions: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  showInvite: boolean;
  myControl = new UntypedFormControl('');
  overrides: GridOverrides;
  options: { minHeight: string };
  scipTabData = {
    name: 'scip_legal_entity',
    app_name: 'SCIP Legal Entity',
    tool: 'composer/new/scip_legal_entity'
  };

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('companyAutocomplete') companyAutocomplete: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;
  suggestions: GlobalCompany[] = [];
  page = 1;
  isLoading = false;
  scipSection!: TeamSettingSection;
  teamSettingSection!: TeamSettingSection;
  epdSection!: TeamSettingSection;
  epdThemeSection!: TeamSettingSection;
  dataSourcesSection!: TeamSettingSection;

  constructor(
    private makersiteService: MakersiteService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<TeamSettingsComponent>
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem('user_info')) {
      this.init();
    }
  }

  init() {
    this.userRid = JSON.parse(localStorage.getItem('user_info')).rid;
    this.teamRid = JSON.parse(localStorage.getItem('team_info')).team_rid;
    this.teamName = JSON.parse(localStorage.getItem('team_info')).team_name;
    this.userRid = this.userRid.replace('#', '');

    if (this.teamRid) {
      this.loadTeamData();
    }
  }

  loadTeamData() {
    this.makersiteService.getComposerData(this.teamRid).subscribe((res: TeamSettingResponse[]) => {
      res.forEach((row) => {
        if (row.sections) {
          this.getTeamInfo(row.sections);
        }
        if (row.actions) {
          this.actions = row.actions;
        }
      });
    });
  }

  getTeamInfo(data: TeamSettingSection[]) {
    // team information
    for (const i in data) {
      if (data[i].name === 'Members') {
        this.teamInfo = data[i];
        let info: Record<string, any> = {};
        data[i].lines.forEach((e) => {
          info = this.getMemberInfo(e);
          info.lines = e;
          if (this.userRid.replace('#', '') === info.rid.replace('#', '')) {
            this.isUserTeamAdmin = info.is_admin;
          }
        });
      } else if (data[i].name === 'Team Settings') {
        this.teamSettingSection = data[i];
      } else if (data[i].name === this.scipTabData.app_name) {
        this.scipSection = data[i];
      } else if (data[i].name === 'Team EPD Settings') {
        this.epdSection = data[i];
      } else if (data[i].name === 'EPD Theme Settings') {
        this.tabs.splice(this.tabs.findIndex((tab) => tab.label == 'EPD') + 1 || 3, 0, { label: 'Color Palette' });
        this.epdThemeSection = data[i];
      } else if (data[i].name === DATA_SOURCES_SECTION_NAME) {
        this.dataSourcesSection = data[i];
      }
    }
  }

  getMemberInfo(data) {
    const membersData: Record<string, any> = {};
    data.forEach((e) => {
      if (e.key.endsWith('.in')) {
        Object.assign(membersData, e);
      } else if (e.key.endsWith('.rid')) {
        membersData.isUserTeamManager = e.label === 'Manager';
      } else {
        const key = e.key.split('.').pop()!;
        membersData[key] = e.value;
      }
    });
    return membersData;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  setActiveTab(selectedTab: any): void {
    this.selectedTab = selectedTab.label;
  }
}
